var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');

module.exports = function() {
    var marker = new Marker('review-flow');
    new Deletism(marker);
    new Undeletism(marker);

    $('.filtertron').filtertron('review-stages', {
        expander: '#filtertronExpander'
    });
};
